import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../assets/svg/redcross.svg'


const _hoisted_1 = /*#__PURE__*/_createVNode("h3", null, "Your Party Bag", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "ion-text-center"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = { class: "add-to-container" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "add-to-button" }, "Add To Existing Party", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Tom's 16th Birthday")
const _hoisted_8 = { class: "contain-center" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Create Party ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, { class: "ion-padding party-bag" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_row, { class: "ion-justify-content-between" }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_ion_button, {
            class: "remove",
            fill: "clear",
            color: "danger",
            size: "large",
            onClick: _ctx.closeModal,
            title: "close",
            style: {"height":"15px"}
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      (_ctx.getPartyBag.suppliers.length == 0)
        ? (_openBlock(), _createBlock("p", _hoisted_3, " Please add suppliers to your bag "))
        : _createCommentVNode("", true),
      (_ctx.getPartyBag.suppliers.length > 0)
        ? (_openBlock(), _createBlock(_component_ion_list, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_grid, { class: "no-pad" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getPartyBag.suppliers, (sup) => {
                    return (_openBlock(), _createBlock(_component_ion_row, {
                      key: sup.id,
                      class: "ion-align-items-center ion-justify-content-start"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, {
                          sizeMd: "2",
                          sizeXs: "3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode("img", {
                              class: "logo",
                              src: 
                'https://suppliers.partyplace.je/storage/' +
                sup.business_logo_path
              
                            }, null, 8, ["src"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ion_col, {
                          sizeMd: "8",
                          sizeXs: "7"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_text, { class: "order" }, {
                              default: _withCtx(() => [
                                _createVNode("h2", null, _toDisplayString(sup.business_name), 1),
                                _createVNode("span", null, _toDisplayString(sup.notes), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ion_col, {
                          sizeMd: "1",
                          sizeXs: "2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_button, {
                              class: "remove",
                              fill: "clear",
                              size: "large",
                              onClick: ($event: any) => (_ctx.removeFromPartyBag(sup.id))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_4
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_ion_list, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_item, { class: "add-padding" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_checkbox, {
                  checked: "true",
                  class: "add-to-checkbox"
                }),
                _createVNode(_component_ion_label, { class: "add-to-label" }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_ion_button, {
          color: "success",
          onClick: _ctx.buildParty,
          disabled: _ctx.getPartyBag.suppliers.length == 0
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ])
    ]),
    _: 1
  }))
}